import React, { useEffect, useState } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import './homepage.css';

const baseURL = process.env.REACT_APP_BASE_URL;
const endpoint_add = '/add_conversation';
const VERCEL_FUNCTION_URL = 'https://demo-agent-bedrock.vercel.app/api/serpapi';

const HomePage = () => {
    const { user } = useAuthenticator((context) => [context.user]);
    const [conversations, setConversations] = useState([]);
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [lastUpdate, setLastUpdate] = useState(null);
    const [debugData, setDebugData] = useState(null);
    const [showDebug, setShowDebug] = useState(false);
    const [searchStats, setSearchStats] = useState(null);

    const addConversation = async () => {
        try {
            let link_server = `${baseURL}${endpoint_add}`
            const response = await fetch(link_server, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id_user: user.username
                })
            });
            const data = await response.json();
            const id_conversation = data.id_conversation;
            window.location.href = `/chat/${id_conversation}`;
        } catch (error) {
            console.error('Error creating new conversation:', error);
        }
    };

    const fetchRetailNews = async () => {
        try {
            setLoading(true);
            setError(null);
            setShowDebug(false);

            // ✨ NUEVO: Define aquí las queries y keywords a enviar
            const pharmaQueries = [
                // Principales competidores de autoservicio y departamentales
                '("Walmart de México" OR Walmex) OR Soriana OR Chedraui OR "La Comer" OR "Palacio de Hierro"',

                // Gigantes del E-commerce y tiendas de conveniencia
                '("Mercado Libre" AND México) OR "Amazon México" OR (OXXO AND FEMSA)',

                // Asociaciones clave y eventos de venta masiva
                'ANTAD AND (ventas OR crecimiento OR reporte) OR "El Buen Fin" OR "Hot Sale"',

                // Tendencias y estrategia de la industria
                '"retail mexicano" AND (inversión OR expansión OR tecnología OR omnicanalidad OR "última milla")',

                // Consumidor y regulación
                '(PROFECO AND ("quejas" OR "quién es quién en los precios")) OR ("confianza del consumidor" AND México)'
            ];

            const pharmaKeywords = [
                // Nombres de Empresas (Retailers)
                'Walmart', 'Walmex', 'Bodega Aurrera', 'Sam\'s Club', 'Soriana', 'Chedraui', 'La Comer', 'HEB',
               'El Palacio de Hierro', 'Sears', 'Coppel', 'Elektra',

                // Tiendas de Conveniencia
                'OXXO', '7-Eleven', 'Circle K',

                // E-commerce y Marketplaces
                'Mercado Libre', 'Amazon México', 'marketplace', 'ventas en línea', 'comercio electrónico',

                // Asociaciones y Organismos
                'ANTAD', 'AMVO', 'PROFECO',

                // Eventos Clave de Ventas
                'El Buen Fin', 'Hot Sale', 'Venta Nocturna', 'Julio Regalado',

                // Conceptos y Tendencias de la Industria
                'retail', 'minorista', 'omnicanalidad', 'logística', 'última milla', 'cadena de suministro',
                'dark store', 'fintech', 'lealtad del cliente', 'marca propia', 'quick commerce',

                // Términos Económicos y de Negocio
                'inversión', 'expansión', 'resultados trimestrales', 'crecimiento', 'ventas', 'consumo privado',
                'inflación', 'confianza del consumidor'
            ];


            console.log('🔍 Obteniendo noticias con petición POST...');

            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 45000);

            // ✏️ MODIFICADO: Cambiar a método POST y agregar el body con los datos
            const response = await fetch(VERCEL_FUNCTION_URL, {
                method: 'POST', // <- Cambiado a POST
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                signal: controller.signal,
                body: JSON.stringify({ // <- Agregado el cuerpo de la petición
                    queries: pharmaQueries,
                    keywords: pharmaKeywords
                })
            });

            clearTimeout(timeoutId);

            // ... (el resto de la lógica para manejar la respuesta no cambia)
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({
                    error: `HTTP ${response.status}: ${response.statusText}`
                }));
                throw new Error(errorData.error || `HTTP ${response.status}`);
            }

            const data = await response.json();
            setDebugData(data);
            console.log('📊 Respuesta de función mejorada:', data);

            if (data.success && data.articles && data.articles.length > 0) {
                const processedArticles = data.articles.map((article, index) => ({
                    ...article,
                    image: article.image || `https://picsum.photos/350/200?random=${Date.now() + index}`,
                    url: article.url && article.url !== '#' && article.url.startsWith('http')
                        ? article.url
                        : null
                }));

                setNews(processedArticles);
                setLastUpdate(new Date());

                if (data.metadata) {
                    setSearchStats(data.metadata);
                }
                console.log(`✅ ${processedArticles.length} noticias obtenidas con filtros estrictos`);

            } else if (data.success === false) {
                console.warn('⚠️ No se encontraron noticias relevantes:', data.message);
                setError(`📰 ${data.message || 'No se encontraron noticias de retail relevantes de la última semana.'}`);

                if (data.debug) {
                    setSearchStats(data.debug);
                }
                setFallbackNews();

            } else {
                throw new Error(data.error || 'Respuesta inesperada de la función');
            }

        } catch (error) {
            console.error('❌ Error obteniendo noticias:', error);
            if (error.name === 'AbortError') {
                setError('⏱️ La búsqueda tardó demasiado tiempo. Las búsquedas con filtros estrictos pueden tardar más.');
            } else {
                setError(`❌ Error: ${error.message}`);
            }
            setFallbackNews();
        } finally {
            setLoading(false);
        }
    };


    const setFallbackNews = () => {
        const fallbackNews = [
            {
                title: 'Mercado Libre México supera las expectativas del Black Friday con 40% más ventas que 2023',
                description: 'La plataforma de e-commerce líder en México registra cifras récord durante la semana del Black Friday, consolidando su posición frente a Amazon México.',
                url: null,
                publishedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
                source: 'E-commerce Today (Ejemplo)',
                image: 'https://picsum.photos/350/200?random=2003',
                position: 3,
                daysAgo: 2
            },
        ];

        setNews(fallbackNews);
        setLastUpdate(new Date());
    };

    useEffect(() => {
        fetchRetailNews();

        const interval = setInterval(() => {
            fetchRetailNews();
        }, 2 * 60 * 60 * 1000);

        return () => clearInterval(interval);
    }, []);

    const formatDate = (dateString) => {
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('es-MX', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch {
            return 'Hace poco';
        }
    };

    const truncateText = (text, maxLength = 150) => {
        if (!text) return '';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };

    const handleRefresh = () => {
        fetchRetailNews();
    };

    const getDaysAgoText = (daysAgo) => {
        if (daysAgo === 0) return 'Hoy';
        if (daysAgo === 1) return 'Ayer';
        return `Hace ${daysAgo} días`;
    };

    return (
        <main className="homepage-main">
            <div className="homepage">
                {/* Header Section */}
                <div className="header-section">
                    <h1 className="main-title">
                        Sector retail México
                    </h1>
                    <p className="subtitle">
                        Noticias de la última semana del  sector retail mexicano con filtros de relevancia estrictos
                    </p>

                    {/* Status indicator */}
                    <div className="status-indicator">
                        <div className="status-dot"></div>
                        {lastUpdate && !loading && (
                            <span className="status-text">
                                Actualizado: {formatDate(lastUpdate)}
                            </span>
                        )}
                    </div>

                    {/* Search stats */}
                    {searchStats && (
                        <div className="search-stats">
                            📊 Queries: {searchStats.queriesExecuted || 'N/A'} |
                            Keywords: {searchStats.keywordFilters || 'N/A'} |
                            Filtros: Título 15, Desc 30, 2+ keywords, última semana
                        </div>
                    )}

                    {/* Action buttons */}
                    <div className="action-buttons">
                        <button
                            onClick={handleRefresh}
                            disabled={loading}
                            className="btn-primary"
                        >
                            {loading ? '🔄 Procesando...' : '🛍️ Actualizar Noticias'}
                        </button>

                        <button
                            onClick={addConversation}
                            className="btn-secondary"
                        >
                            💬 Nueva Conversación
                        </button>
                    </div>
                </div>

                {/* Loading State */}
                {loading && (
                    <div className="loading-container">
                        <div className="loading-spinner">⚡</div>
                        <div className="loading-title">
                            Ejecutando múltiples búsquedas...
                        </div>
                        <div className="loading-subtitle">
                            Aplicando filtros de relevancia estrictos
                        </div>
                        <div className="loading-note">
                            Esto puede tardar 30-45 segundos
                        </div>
                    </div>
                )}

                {/* Error State */}
                {error && (
                    <div className="error-container">
                        ⚠️ {error}
                        <div className="error-details">
                            <strong>💡 Información sobre la búsqueda avanzada:</strong><br />
                            • La función ejecuta 4 queries diferentes con filtros estrictos<br />
                            • Requiere 2+ keywords de retail por artículo<br />
                            • Filtra títulos cortos y descripciones vacías<br />
                            • Puede tardar más tiempo pero da resultados más relevantes
                        </div>
                    </div>
                )}

                {/* News Grid */}
                <div className="news-grid">
                    {news.map((article, index) => (
                        <div
                            key={`${article.title}-${index}`}
                            className={`news-card fade-in-up ${!article.url ? 'disabled' : ''}`}
                            style={{ animationDelay: `${index * 0.05}s` }}
                            onClick={() => article.url && window.open(article.url, '_blank')}
                        >
                            {/* Image Container */}
                            <div className="news-image-container">
                                <img
                                    className="news-image"
                                    src={article.image}
                                    alt={article.title}
                                    onError={(e) => {
                                        e.target.src = `https://via.placeholder.com/320x160/3498db/ffffff?text=Retail+MX+${article.position || index + 1}`;
                                    }}
                                />

                                {article.daysAgo !== undefined && (
                                    <div className="image-overlay-date">
                                        {getDaysAgoText(article.daysAgo)}
                                    </div>
                                )}
                            </div>

                            {/* Content */}
                            <div className="news-content">
                                {/* Source and Date */}
                                <div className="news-meta">
                                    <span className="news-source">
                                        {article.source}
                                    </span>
                                    <span className="news-date">
                                        {formatDate(article.publishedAt)}
                                    </span>
                                </div>

                                {/* Title */}
                                <h3 className="news-title">
                                    {article.title}
                                </h3>

                                {/* Footer */}
                                <div className="news-footer">
                                    <div className={`news-read-link ${!article.url ? 'disabled' : ''}`}>
                                        📖 {!article.url ? 'Ejemplo' : 'Leer'}
                                    </div>
                                    <div className="news-tag">
                                        🛍️ RETAIL
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Empty State */}
                {!loading && news.length === 0 && !error && (
                    <div className="empty-state">
                        <div className="empty-icon">📰</div>
                        <div className="empty-title">
                            Los filtros estrictos no encontraron noticias de retail relevantes de la última semana.
                        </div>
                        <div className="empty-subtitle">
                            Intenta refrescar más tarde o verifica el Debug Avanzado para más información.
                        </div>
                    </div>
                )}

                {/* Footer Info */}
                <div className="footer-info">
                    <div className="footer-main">
                        ⏰ <strong>Actualización automática:</strong> Cada 2 horas
                    </div>
                    <div className="footer-detail">
                        ⏱️ <strong>Período:</strong> Últimos 7 días con verificación de fechas
                    </div>
                </div>
            </div>
        </main>
    );
};

export default HomePage;